import { AppSpan, CustomContainer, FixedContainer, SidePopupContainer } from "src/style"
import { exportData } from "src/utils/data-export"


export const ExportTypes: React.FC<any> = ({data, customClass, close}) => {

    function handleClick () {
        exportData(data)
        close()
    }
    
    return (
        <>
            <SidePopupContainer zIndex="7" onClick={close} bgColor='transparent' />
            <FixedContainer top="14" right="3" zIndex="8" className={customClass || ''}>
                <CustomContainer
                    width="11.9" minHeight="10.6" bgColor="#ffffff"
                    borderColor="#F7FAFC" padding="1" radius="0.4"
                    shadow="0px 0px 1px rgba(12, 26, 75, 0.1), 0px 30px 40px rgba(20, 37, 63, 0.08)"
                >
                    <AppSpan className="export-type-text" onClick={handleClick} >PDF</AppSpan>
                    <AppSpan className="export-type-text" onClick={handleClick} >EXCEL</AppSpan>
                    <AppSpan className="export-type-text" onClick={handleClick}>CSV</AppSpan>
                </CustomContainer>
            </FixedContainer>
        </>
    )
}